import { Report } from "../../../../scripts/reports/Report";
import { RejectedFailuresByReasonConfig } from "../../../charts/pie/retreading/RejectedFailuresByReason";
import { TooltipConfig } from "../../../charts/pie/TooltipConfig";

import { toPercentage } from "@/utils/helpers/StringHelper";
import { toCommas, getRounded, getPercentage } from "@/utils/helpers/NumberHelper";

import { PIE_COLORS } from "@/utils/constants/FleetDashboard.constants";

import {
    DatasetOutlabels,
    DatasetItem as PieDatasetItem,
} from "../../../charts/pie/Dataset";

import {
    TAB_TYPES,
    TableFields,
    REPORT_TYPE
} from "@/utils/constants/FleetDashboard.constants.js"


const REJECTED_FAILURES_CONFIG = {
    [REPORT_TYPE.REJECTED_TIRE_FAILURES_BY_REASON]: {
        quantityKey: "RejectTires"
    },
    [REPORT_TYPE.REJECTED_WHEEL_FAILURES_BY_REASON]: {
        quantityKey: "RejectWheels"
    }
};

class RejectedFailuresByReasonReport extends Report {
    constructor(data, settings, models, loader) {
        super({ reportType: data.report_type, tabType: TAB_TYPES.RETREADING }, settings, models, loader);

        this.config = REJECTED_FAILURES_CONFIG[this.reportType];

        if (data?.tables) {
            this.tableItems = Object.values(data.tables)[0] || [];
        }

        if (data?.graphs) {
            this.chartItems = data.graphs["0"];
        }

        this.settings.tireStatuses = null;
        this.settings.wheelPositions = null;
        this.settings.serviceTypes = null;
        this.settings.unitLocations = null;
        this.settings.isIncludeNatAvg = null;
        this.settings.isComparePrev = null;

        this.tableFields = TableFields[this.reportType];
    }

    tableItems = [];
    chartItems = null;
    isTableSelectable = false;
    tableFields = [];

    buildChart() {
        if (!this.chartItems || !this.config) return null;

        const { quantityKey } = this.config;

        const total =
            this.chartItems.reduce((acc, curr) => acc + (curr[quantityKey] || 0), 0) || 0;

        const points = [];
        const labels = [];

        this.chartItems.forEach((item, idx) => {
            const value = item[quantityKey] || 0;

            const tooltip = {
                content: [
                    {
                        text: `${item["RejectReason"]} - ${toPercentage(
                            getRounded(getPercentage(value, total), 0)
                        )}`
                    },
                    {
                        text: 'Quantity',
                        value: toCommas(value),
                        fontWeight: 'normal'
                    }
                ]
            };

            points.push(new PieDatasetItem({
                datasetId: 'RejectReason',
                dataItem: value,
                tooltip,
                color: PIE_COLORS[idx]
            }));

            labels.push(item["RejectReason"]);
        });

        const outlabels = new DatasetOutlabels({ text: "%p" });

        return { points, labels, outlabels };
    }

    getChartConfig(id) {
        const current = this.buildChart();
        const config = new RejectedFailuresByReasonConfig(current);
        config.options.tooltips = new TooltipConfig(id);
        return config;
    }

    getChartItems() {
        return this.chartItems;
    }

    getFilteredFields() {
        return this.tableFields || [];
    }

    getTableItems() {
        return this.tableItems;
    }

    getDisabledAddBtn() {
        return !this.tableItems.length;
    }
}

export {
    RejectedFailuresByReasonReport
};